import { useLayoutEffect, useRef } from "react";
import { useLocation } from 'react-router-dom'
import { trackPageView, trackPageVisit } from "./gtm";

const ScrollToTop = ({children}) => {
    const location = useLocation();
    const isFirstRender = useRef(true);

    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);

      // Our own DB records every visit, including the first hard load.
      trackPageVisit(location.pathname + location.search);

      // GTM base tag already fires a page_view for the initial hard load
      // (see public/index.html); only push virtual page_views for
      // client-side route changes so GTM/GA4 tags see every page.
      if (isFirstRender.current) {
        isFirstRender.current = false;
      } else {
        trackPageView(location.pathname + location.search);
      }
    }, [location.pathname, location.search]);
    return children
};

export default ScrollToTop;